module.exports = __webpack_public_path__ + "img/icon.07461c21.png";